import Localization from 'lib/localization';

export default {
    lxTitle() {
        return Localization.get('badoo_homepage@captcha.page.title');
    },

    lxBody() {
        return Localization.get('badoo_homepage@captcha.page.body');
    },

    lxFieldLabel() {
        return Localization.get('badoo_homepage@captcha.page.field.label');
    },

    lxButtonSubmit() {
        return Localization.get('badoo_homepage@captcha.page.button_submit');
    },

    lxButtonReload() {
        return Localization.get('badoo_homepage@captcha.reload.label');
    },
};
